(function () {
  if (window.WSPGiftStock) return;
  const root = () => window.Shopify?.routes?.root || '/';
  let running = null;
  const read = async (url, options = {}) => {
    const response = await fetch(url, { headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, cache: 'no-store', ...options });
    if (!response.ok) throw new Error('Cart availability check failed: ' + response.status);
    return response.json();
  };
  const clean = () => {
    if (running) return running;
    running = (async () => {
      let cart = await read(root() + 'cart.js');
      const gifts = cart.items.filter(i => i.properties?._wsp_promotion_gift === 'true');
      const products = new Map();
      const updates = {};
      await Promise.all(gifts.map(async item => {
        try {
          const url = new URL(item.url, window.location.origin);
          url.pathname += '.js'; url.search = '';
          if (!products.has(url.href)) products.set(url.href, read(url.href));
          const product = await products.get(url.href);
          const variant = product.variants.find(v => String(v.id) === String(item.variant_id));
          if (variant?.available === false) updates[item.key] = 0;
        } catch (error) { console.warn('[WSP gifts] Availability unconfirmed', error); }
      }));
      if (Object.keys(updates).length) {
        cart = await read(root() + 'cart/update.js', { method: 'POST', body: JSON.stringify({ updates }) });
        const ids = [...document.querySelectorAll('cart-items-component')].map(el => el.dataset.sectionId).filter(Boolean);
        let sections = {};
        if (ids.length) {
          try { sections = await read(root() + '?' + new URLSearchParams({ sections: ids.join(',') })); } catch (error) { console.warn(error); }
        }
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: {
          resource: cart, sourceId: 'wsp-stock-cleanup', data: { source: 'wsp-stock-cleanup', sections }
        } }));
      }
      return cart;
    })().finally(() => { running = null; });
    return running;
  };
  window.WSPGiftStock = { clean };
  const boot = () => { void clean().catch(error => console.warn('[WSP gifts]', error)); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
  document.addEventListener('cart:update', event => {
    if (event.detail?.sourceId !== 'wsp-stock-cleanup') boot();
  });
  let checkoutBusy = false;
  document.addEventListener('click', async event => {
    const target = event.target?.closest?.('button[name="checkout"], input[name="checkout"], #checkout, a[href$="/checkout"]');
    if (!target || target.disabled) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (checkoutBusy) return;
    checkoutBusy = true;
    target.setAttribute('aria-busy', 'true');
    try {
      await clean();
      window.location.href = root() + 'checkout';
    } catch (error) {
      console.warn('[WSP gifts] Retrying checkout availability', error);
      window.location.href = root() + 'checkout';
    } finally { checkoutBusy = false; target.removeAttribute('aria-busy'); }
  }, true);
})();

/* WSP v2 buy box (product page + quick view) and quick-view dialog. */
/* UI strings: zh / en / ms, picked from Shopify.locale (falls back to <html lang>, then zh). */
window.WSP_STR = window.WSP_STR || {
  zh: { unlocked: '已解锁全马包邮', left_a: '还差 ', left_b: ' 解锁全马包邮', approx: '约 ', unit: '罐', total: ' · 共 ', add_fail: '加入购物车失败，请重试', quick: '快速选购', close: '关闭', loading: '加载中…', update_cart: '更新购物车 · ', load_fail: '加载失败，', see_page: '点这里看产品页', saving: '保存中…', saved: '已保存 ✓', confirm: '确认' },
  en: { unlocked: "You've unlocked free shipping", left_a: 'Add ', left_b: ' more for free shipping', approx: 'About ', unit: 'bottle', total: ' · total ', add_fail: "Couldn't add to cart. Please try again.", quick: 'Quick shop', close: 'Close', loading: 'Loading…', update_cart: 'Update cart · ', load_fail: "Couldn't load. ", see_page: 'View the product page', saving: 'Saving…', saved: 'Saved ✓', confirm: 'Save' },
  ms: { unlocked: 'Layak penghantaran percuma', left_a: 'Tambah ', left_b: ' lagi untuk penghantaran percuma', approx: 'Kira-kira ', unit: 'botol', total: ' · jumlah ', add_fail: 'Gagal tambah ke troli. Sila cuba lagi.', quick: 'Beli pantas', close: 'Tutup', loading: 'Memuatkan…', update_cart: 'Kemas kini troli · ', load_fail: 'Gagal dimuatkan. ', see_page: 'Lihat halaman produk', saving: 'Menyimpan…', saved: 'Disimpan ✓', confirm: 'Simpan' }
};
window.WSP_T = window.WSP_T || function (key) {
  let l = ((window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'zh').slice(0, 2).toLowerCase();
  if (!window.WSP_STR[l]) l = 'zh';
  return window.WSP_STR[l][key];
};
window.wspGiftCountdownTick = window.wspGiftCountdownTick || function () {
  document.querySelectorAll('[data-wsp-gift-countdown]').forEach((timer) => {
    const end = new Date(timer.dataset.end).getTime();
    const remaining = Math.max(0, end - Date.now());
    const feature = timer.closest('[data-wsp-gift-expiring-feature]');
    if (feature) feature.hidden = remaining === 0;
    const units = {
      days: Math.floor(remaining / 86400000),
      hours: Math.floor((remaining % 86400000) / 3600000),
      minutes: Math.floor((remaining % 3600000) / 60000),
      seconds: Math.floor((remaining % 60000) / 1000)
    };
    Object.entries(units).forEach(([key, value]) => {
      const node = timer.querySelector('[data-' + key + ']');
      if (node) node.textContent = String(value).padStart(2, '0');
    });
    const time = timer.querySelector('.wsp2-giftcountdown__time');
    const ended = timer.querySelector('.wsp2-giftcountdown__ended');
    if (time) time.hidden = remaining === 0;
    if (ended) ended.hidden = remaining !== 0;
  });
};
window.wspGiftCountdownTick();
if (!window.wspGiftCountdownInterval) {
  window.wspGiftCountdownInterval = window.setInterval(window.wspGiftCountdownTick, 1000);
};

if (!customElements.get('wsp-pdp')) {
  customElements.define('wsp-pdp', class extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.tiers = Array.from(this.querySelectorAll('.wsp2-tier'));
      try { this.gifts = JSON.parse(this.querySelector('[data-gifts]').textContent || '{}'); } catch (e) { this.gifts = {}; }
      this.threshold = Number(this.dataset.threshold || 0);
      this.cartTotal = Number(this.dataset.cartTotal || 0);
      this.moneyFormat = this.dataset.moneyFormat || 'RM{{amount}}';
      this.qtyInput = this.querySelector('[data-qty]');
      this.current = this.tiers.find((t) => t.classList.contains('is-on')) || this.tiers[0];
      this.tiers.forEach((t) => t.addEventListener('click', () => this.select(t)));
      this.querySelectorAll('[data-goto]').forEach((b) => b.addEventListener('click', () => {
        const t = this.tiers[Number(b.dataset.goto) - 1];
        if (t) { this.select(t); t.focus(); }
      }));
      this.querySelectorAll('[data-qty-step]').forEach((b) => b.addEventListener('click', () => {
        this.setQty(this.qty() + Number(b.dataset.qtyStep));
      }));
      if (this.qtyInput) this.qtyInput.addEventListener('change', () => this.setQty(this.qty()));
      this.querySelectorAll('[data-atc]').forEach((b) => b.addEventListener('click', () => this.add(b)));
      this.setupSwipeGallery();
      if (this.current) this.select(this.current, true);
      this.setupMobileBundleSheet();
      this.refreshCart();
      this._onCart = (e) => {
        const c = e.detail && e.detail.resource;
        if (c && typeof c.total_price === 'number') { this.cartTotal = c.total_price; this.updateShip(); }
      };
      document.addEventListener('cart:update', this._onCart);
      const sticky = this.querySelector('[data-sticky]');
      if (sticky) {
        this._updateSticky = () => {
          const doc = document.documentElement;
          const remaining = doc.scrollHeight - (window.scrollY + window.innerHeight);
          const revealDistance = Math.max(180, Math.min(320, window.innerHeight * 0.3));
          sticky.hidden = remaining > revealDistance;
        };
        this._onStickyScroll = () => {
          if (this._stickyFrame) return;
          this._stickyFrame = window.requestAnimationFrame(() => {
            this._stickyFrame = 0;
            this._updateSticky();
          });
        };
        window.addEventListener('scroll', this._onStickyScroll, { passive: true });
        window.addEventListener('resize', this._onStickyScroll);
        this._updateSticky();
      }
    }
    disconnectedCallback() {
      clearInterval(this._sheetCountdown);
      if (this._bundleMq) this._bundleMq.removeEventListener('change', this._bundleResize);
      if (this.bundleSheet?.open) this.bundleSheet.close();
      if (this._onCart) document.removeEventListener('cart:update', this._onCart);
      if (this._onStickyScroll) {
        window.removeEventListener('scroll', this._onStickyScroll);
        window.removeEventListener('resize', this._onStickyScroll);
      }
      if (this._stickyFrame) window.cancelAnimationFrame(this._stickyFrame);
    }

    setupSwipeGallery() {
      const main=this.querySelector('[data-main-image]');
      const strip=this.querySelector('.wsp2-pdp__thumbs');
      this.galleryThumbs=[...this.querySelectorAll('.wsp2-pdp__thumb')];
      if(!main || !strip || !this.galleryThumbs.length)return;
      main.loading='eager';main.decoding='async';main.draggable=false;
      this._galleryCache=new Map();
      const sized=src=>{try{const url=new URL(src,location.origin);url.searchParams.set('width',matchMedia('(max-width:767px)').matches?'900':'1400');return url.href;}catch{return src;}};
      this.galleryThumbs.forEach(t=>{t.dataset.gallerySrc=sized(t.dataset.full);});
      const preload=index=>{
        const thumb=this.galleryThumbs[index];if(!thumb)return;
        const src=thumb.dataset.gallerySrc;if(this._galleryCache.has(src))return this._galleryCache.get(src);
        const img=new Image();img.decoding='async';img.src=src;this._galleryCache.set(src,img);return img;
      };
      const show=index=>{
        index=Math.max(0,Math.min(this.galleryThumbs.length-1,index));
        const thumb=this.galleryThumbs[index];const src=thumb.dataset.gallerySrc;
        const request=++this._galleryRequest;
        this.galleryThumbs.forEach(t=>{t.classList.toggle('is-on',t===thumb);t.setAttribute('aria-current',t===thumb?'true':'false');});
        const full=preload(index);
        main.removeAttribute('srcset');
        main.alt=thumb.querySelector('img')?.alt || main.alt;
        if(full.complete && full.naturalWidth){main.src=src;}
        else {
          main.src=thumb.querySelector('img')?.currentSrc || src;
          full.onload=()=>{if(this._galleryRequest===request)main.src=src;};
        }
        const left=thumb.offsetLeft-strip.offsetLeft;
        if(left<strip.scrollLeft)strip.scrollTo({left,behavior:'smooth'});
        else if(left+thumb.offsetWidth>strip.scrollLeft+strip.clientWidth)strip.scrollTo({left:left+thumb.offsetWidth-strip.clientWidth,behavior:'smooth'});
        preload(index-1);preload(index+1);
      };
      this._galleryRequest=0;
      this.galleryThumbs.forEach((thumb,index)=>{
        thumb.addEventListener('click',()=>show(index));
        thumb.addEventListener('pointerenter',()=>preload(index),{passive:true});
        thumb.addEventListener('focus',()=>preload(index));
      });
      const area=main.closest('.wsp2-pdp__main') || main;
      let start=null;
      area.addEventListener('pointerdown',e=>{if(e.isPrimary && e.button===0)start={x:e.clientX,y:e.clientY,id:e.pointerId};},{passive:true});
      area.addEventListener('pointerup',e=>{
        if(!start || start.id!==e.pointerId)return;
        const dx=e.clientX-start.x,dy=e.clientY-start.y;start=null;
        if(Math.abs(dx)<40 || Math.abs(dx)<Math.abs(dy)*1.25)return;
        const index=this.galleryThumbs.findIndex(t=>t.classList.contains('is-on'));
        show((index<0?0:index)+(dx<0?1:-1));
      },{passive:true});
      area.addEventListener('pointercancel',()=>{start=null;},{passive:true});
      const active=this.galleryThumbs.findIndex(t=>t.classList.contains('is-on'));
      preload(active<0?0:active);preload((active<0?0:active)+1);
    }

    setupMobileBundleSheet() {
      if (!this.closest('#buy') || this.closest('dialog') || !this.tiers.length) return;
      let tiers = this.querySelector('.wsp2-pdp__tiers');
      if(!tiers && this.tiers.length){tiers=document.createElement('div');tiers.className='wsp2-pdp__tiers';tiers.setAttribute('role','radiogroup');this.querySelector('.wsp2-buy').prepend(tiers);this.tiers.forEach(t=>{t.hidden=false;tiers.append(t);});}
      const price = this.querySelector('.sam-im8-price-summary');
      if (!tiers || !price) return;
      const locale = ((window.Shopify && Shopify.locale) || document.documentElement.lang || 'zh').slice(0,2);
      const words = locale === 'en' ? ['Choose your bundle','Confirm add to cart','Close'] : locale === 'ms' ? ['Pilih pakej','Sahkan tambah ke troli','Tutup'] : ['选择配套','确认加入购物车','关闭'];
      const singleBundle = this.tiers.length === 1;
      if (singleBundle) {
        tiers.hidden = true;
        tiers.style.setProperty('display', 'none', 'important');
        words[0] = locale === 'en' ? 'Confirm your bundle' : locale === 'ms' ? 'Sahkan pakej' : '确认配套';
      }
      const sheet = document.createElement('dialog');
      sheet.className = 'wsp48-bundle-sheet';
      sheet.setAttribute('aria-label', words[0]);
      sheet.innerHTML = '<header><h2></h2><button type="button" class="wsp48-sheet-close"></button></header><div class="wsp48-sheet-product"><img alt="" width="96" height="96"><div><strong></strong><p class="wsp48-sheet-selection"></p></div></div><div class="wsp48-sheet-options"></div><button type="button" class="wsp48-sheet-confirm"></button>';
      sheet.querySelector('h2').textContent = words[0];
      const close = sheet.querySelector('.wsp48-sheet-close');
      close.textContent = '×'; close.setAttribute('aria-label',words[2]);
      sheet.querySelector('strong').textContent = this.querySelector('h1')?.textContent || '';
      const confirm = sheet.querySelector('.wsp48-sheet-confirm');
      confirm.textContent = words[1];
      confirm.addEventListener('click', () => this.add(confirm));
      close.addEventListener('click', () => sheet.close());
      sheet.addEventListener('click', e => { if (e.target === sheet) { const r=sheet.getBoundingClientRect(); if(e.clientY<r.top || e.clientX<r.left || e.clientX>r.right) sheet.close(); } });
      sheet.addEventListener('close', () => { document.documentElement.style.overflow = this._sheetPreviousOverflow || ''; this._sheetTrigger?.focus(); if(!this._bundleMq.matches)this._bundleMovable.forEach(({node,marker})=>marker.after(node)); });
      tiers.closest('.wsp2-buy').appendChild(sheet);
      this.bundleSheet = sheet;
      this.bundleSheetConfirm = confirm;
      const pricing=document.createElement('div'); pricing.className='wsp48-sheet-pricing'; confirm.before(pricing);
      const content=document.createElement('div'); content.className='wsp48-sheet-scroll';
      const footer=document.createElement('div'); footer.className='wsp48-sheet-footer';
      sheet.querySelector('header').after(content);
      content.append(sheet.querySelector('.wsp48-sheet-product'),pricing);
      footer.append(sheet.querySelector('.wsp48-sheet-options'),confirm); sheet.append(footer);
      const movable = [tiers, price, this.querySelector('[data-error]')].filter(Boolean);
      this._bundleMovable = movable.map(node => { const marker=document.createComment('bundle-sheet-position'); node.before(marker); return {node,marker}; });
      const mq = window.matchMedia('(max-width: 767px)');
      this._bundleMq = mq;
      this._bundleResize = () => {
        if (mq.matches) {
          this._bundleMovable.forEach(({node}) => sheet.querySelector('.wsp48-sheet-options').appendChild(node));
        } else {
          if(sheet.open) sheet.close();
          this._bundleMovable.forEach(({node,marker}) => marker.after(node));
        }
      };
      mq.addEventListener('change',this._bundleResize);
      this._bundleResize();
    }

    updateMobileSheetPrice() {
      if(!this.bundleSheet || !this.current) return;
      const t=this.current;
      let giftText=this.bundleSheet.querySelector('.wsp48-sheet-gift-text');
      if(!giftText){giftText=document.createElement('p');giftText.className='wsp48-sheet-gift-text';this.bundleSheet.querySelector('.wsp48-sheet-product').append(giftText);}
      const giftLocale=((window.Shopify && Shopify.locale) || document.documentElement.lang || 'zh').slice(0,2);
      const giftNames=giftLocale==='en'?{snack_small:'Herbal Snack (small pack)',snack_bottle:'Herbal Snack',jtc_small:'Gluco Lower Tea sachets',soup_ginseng:'Ginseng Root Soup',soup_lions_mane:'Lion’s Mane & Chinese Yam Soup',sleep:'E-ssential sleep sticks'}:giftLocale==='ms'?{snack_small:'Snek Herba (pek kecil)',snack_bottle:'Snek Herba',jtc_small:'Uncang Teh Gluco Lower',soup_ginseng:'Sup Akar Ginseng',soup_lions_mane:'Sup Cendawan Lion’s Mane & Keladi Cina',sleep:'E-ssential'}:{snack_small:'药材零食小包',snack_bottle:'药材零食',jtc_small:'降糖茶包',soup_ginseng:'参须炖汤',soup_lions_mane:'猴头菇淮山汤',sleep:'睡眠好物'};
      const endTime=new Date(this.querySelector('[data-gifts]')?.dataset.wspGiftEnd || 0).getTime();
      const selectedGifts=(this.gifts[t.dataset.variant] || []).filter(g=>Date.now()<endTime || !String(g[2]).includes('soup_'));
      giftText.textContent=selectedGifts.length ? (giftLocale==='en'?'Free gifts: ':giftLocale==='ms'?'Hadiah percuma: ':'加赠：')+selectedGifts.map(g=>(giftNames[g[2]] || String(g[2]))+' ×'+g[1]).join(' ＋ ') : '';
      giftText.hidden=!selectedGifts.length;
      const base=Number(t.dataset.priceCents || 0);
      const final=Number(t.dataset.sheetFinal || base);
      const original=Math.max(base,Number(t.dataset.compareCents || 0));
      const bundle=Math.max(0,original-base);
      const promo=Math.max(0,base-final);
      const percent=base ? Math.round(promo/base*100) : 0;
      const locale=((window.Shopify && Shopify.locale) || document.documentElement.lang || 'zh').slice(0,2);
      const labels=locale==='en' ? ['Original price','Bundle savings','48th anniversary offer','Total','You save'] : locale==='ms' ? ['Harga asal','Penjimatan pakej','Promosi ulang tahun ke-48','Jumlah','Anda jimat'] : ['商品原价','配套优惠','48周年活动优惠','实付款','已为您节省'];
      const box=this.bundleSheet.querySelector('.wsp48-sheet-pricing'); box.replaceChildren();
      const row=(label,value,cls) => {const line=document.createElement('div'); if(cls)line.className=cls;const text=document.createElement('span');text.textContent=label;const amount=document.createElement('b');amount.textContent=value;line.append(text,amount);box.append(line);};
      row(labels[0],this.money(original));
      if(bundle>0)row(labels[1],'−'+this.money(bundle));
      if(promo>0){
        row(labels[2]+' (−'+percent+'%)','−'+this.money(promo),'wsp48-sheet-promo');
        const timer=document.createElement('span');timer.className='wsp48-sheet-countdown';timer.setAttribute('aria-label',locale==='zh'?'周年优惠倒数':'Anniversary offer countdown');
        box.querySelector('.wsp48-sheet-promo>span').append(timer);
        const tick=()=>{
          const end=new Date(this.querySelector('[data-gifts]')?.dataset.wspGiftEnd || 0).getTime();
          const remaining=Math.max(0,end-Date.now());
          const days=Math.floor(remaining/86400000);
          const hours=Math.floor(remaining%86400000/3600000);
          const minutes=Math.floor(remaining%3600000/60000);
          const seconds=Math.floor(remaining%60000/1000);
          timer.textContent=remaining>0 ? (days>0?days+(locale==='zh'?'天 ':'d '):'')+[hours,minutes,seconds].map(n=>String(n).padStart(2,'0')).join(':') : (locale==='zh'?'已结束':'Ended');
        };
        clearInterval(this._sheetCountdown);tick();this._sheetCountdown=setInterval(tick,1000);
      } else {clearInterval(this._sheetCountdown);}
      row(labels[3],this.money(final),'wsp48-sheet-total');
      if(original>final)row(labels[4],this.money(original-final),'wsp48-sheet-saving');
    }

    openMobileBundleSheet(trigger) {
      const sheet=this.bundleSheet;
      this._bundleMovable.forEach(({node}) => sheet.querySelector('.wsp48-sheet-options').appendChild(node));
      this._sheetTrigger=trigger;
      const img=sheet.querySelector('img');
      img.src=this.current?.dataset.mediaFull || this.querySelector('[data-main-image]')?.src || '';
      sheet.querySelector('.wsp48-sheet-selection').textContent=this.current?.dataset.label || '';
      this._sheetPreviousOverflow=document.documentElement.style.overflow;
      this.updateMobileSheetPrice();
      sheet.showModal();
      document.documentElement.style.overflow='hidden';
    }

    qty() { return Math.max(1, Math.min(20, parseInt(this.qtyInput ? this.qtyInput.value : 1, 10) || 1)); }
    setQty(n) {
      if (this.qtyInput) this.qtyInput.value = Math.max(1, Math.min(20, n || 1));
      this.updatePrice();
      this.updateShip();
    }
    money(cents) {
      const v = (cents / 100).toFixed(2).replace(/\.00$/, '');
      const withCommas = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return this.moneyFormat.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, withCommas);
    }
    root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
    async refreshCart() {
      try {
        const cart = await (await fetch(this.root() + 'cart.js', { headers: { Accept: 'application/json' } })).json();
        this.cartTotal = cart.total_price || 0;
      } catch (e) { /* keep server value */ }
      this.updateShip();
    }
    lineCents() { return Number(this.current ? this.current.dataset.priceCents || 0 : 0) * this.qty(); }
    updatePrice() {
      const el = this.querySelector('[data-atc-price]');
      if (el) el.textContent = this.money(Number(this.current?.dataset.sheetFinal || this.current?.dataset.priceCents || 0) * this.qty());
      const sp = this.querySelector('[data-sticky-price]');
      if (sp) sp.textContent = this.money(Number(this.current?.dataset.sheetFinal || this.current?.dataset.priceCents || 0) * this.qty());
    }
    updateShip() {
      const box = this.querySelector('[data-ship]');
      if (!box || !this.current) return;
      const tier = this.lineCents();
      const total = this.cartTotal + tier;
      box.querySelector('[data-ship-cart]').textContent = this.money(this.cartTotal);
      box.querySelector('[data-ship-tier]').textContent = this.money(tier);
      const unlocked = total >= this.threshold;
      const pct = this.threshold > 0 ? Math.min(100, Math.round((total / this.threshold) * 100)) : 100;
      box.querySelector('[data-ship-fill]').style.width = pct + '%';
      box.classList.toggle('is-unlocked', unlocked);
      const msg = box.querySelector('[data-ship-msg]');
      msg.textContent = '';
      if (unlocked) {
        msg.textContent = window.WSP_T('unlocked');
      } else {
        msg.appendChild(document.createTextNode(window.WSP_T('left_a')));
        const b = document.createElement('b'); b.textContent = this.money(this.threshold - total); msg.appendChild(b);
        msg.appendChild(document.createTextNode(window.WSP_T('left_b')));
      }
    }
    select(t, initial) {
      if (t.disabled) return;
      this.current = t;
      this.tiers.forEach((x) => { const on = x === t; x.classList.toggle('is-on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
      const q = (sel) => this.querySelector(sel);
      const p = q('.wsp2-pdp__price [data-price]'); if (p) p.textContent = t.dataset.price;
      const c = q('.wsp2-pdp__price [data-compare]'); if (c) { c.textContent = t.dataset.compare; c.hidden = !t.dataset.compare; }
      const sv = q('.wsp2-pdp__price [data-save]'); if (sv) { sv.textContent = t.dataset.save; sv.hidden = !t.dataset.save; }
      const per = q('.wsp2-pdp__per[data-per]');
      if (per) {
        const units = Number(t.dataset.units || 1);
        per.textContent = window.WSP_T('approx');
        const b = document.createElement('b'); b.textContent = t.dataset.per; per.appendChild(b);
        per.appendChild(document.createTextNode(' / ' + (this.dataset.unit || window.WSP_T('unit')) + (units > 1 ? window.WSP_T('total') + t.dataset.label : '')));
      }
      const sl = q('[data-sticky-label]'); if (sl) sl.textContent = t.dataset.label;
      if (t.dataset.mediaFull && !(initial && this.closest('#buy') && !this.closest('dialog'))) {
        const main = q('[data-main-image], .wsp2-qv__img img');
        if (main) {
          main.src = t.dataset.mediaFull;
          main.removeAttribute('srcset');
        }
        this.querySelectorAll('.wsp2-pdp__thumb').forEach((thumb) => {
          thumb.classList.toggle('is-on', thumb.dataset.mediaId === t.dataset.mediaId);
        });
      }
      this.querySelectorAll('[data-gift-panel]').forEach((panel) => { panel.hidden = panel.dataset.giftPanel !== t.dataset.pos; });
      if (this.bundleSheet) {
        const img=this.bundleSheet.querySelector('img');
        img.src=t.dataset.mediaFull || q('[data-main-image]')?.src || '';
        this.bundleSheet.querySelector('.wsp48-sheet-selection').textContent=t.dataset.label || '';
        this.updateMobileSheetPrice();
      }
      this.updatePrice();
      this.updateShip();
      if (!initial && !this.closest('dialog')) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', t.dataset.variant);
        window.history.replaceState({}, '', url.toString());
      }
    }
    async add(btn) {
      if (this.bundleSheet && btn !== this.bundleSheetConfirm) { this.openMobileBundleSheet(btn); return; }
      if (this._adding || !this.current || this.current.disabled) return;
      this._adding = true;
      const err = this.querySelector('[data-error]');
      if (err) err.hidden = true;
      const variantId = this.current.dataset.variant;
      const qty = this.qty();
      const buttons = [...this.querySelectorAll('[data-atc]'), ...(this.bundleSheetConfirm ? [this.bundleSheetConfirm] : [])];
      buttons.forEach(b => { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
      const root = this.root();
      const json = async (path, body) => {
        const response = await fetch(root + path, {
          headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
          ...(body ? { method: 'POST', body: JSON.stringify(body) } : { cache: 'no-store' })
        });
        const data = await response.json();
        if (!response.ok || data.status || data.errors) {
          const error = new Error(data.description || data.message || window.WSP_T('add_fail'));
          error.status = response.status;
          throw error;
        }
        return data;
      };
      try {
        // Check existing gifts and refresh gift stock together; neither mutates paid items.
        const [before, giftState] = await Promise.all([
          window.WSPGiftStock ? window.WSPGiftStock.clean() : json('cart.js'),
          (async () => {
        let giftMap = {};
        let stock = {};
        // Re-read the section at click time: cached tabs must not promise old stock.
        try {
          const info = this.querySelector('[data-gift-stock]');
          const url = new URL(info.dataset.productUrl, window.location.origin);
          url.searchParams.set('section_id', 'wsp-v2-quickview');
          url.searchParams.set('_stock', String(Date.now()));
          const response = await fetch(url, { cache: 'no-store' });
          if (!response.ok) throw new Error('Gift availability unavailable');
          const fresh = new DOMParser().parseFromString(await response.text(), 'text/html');
          giftMap = JSON.parse(fresh.querySelector('[data-gifts]').textContent);
          stock = JSON.parse(fresh.querySelector('[data-gift-stock]').textContent).variants;
        } catch (error) {
          // Unknown gift availability must never prevent buying the paid product.
          console.warn('[WSP gifts] Skipped unverified gifts', error);
        }
            return { giftMap, stock };
          })()
        ]);
        const { giftMap, stock } = giftState;
        const dlg = this.closest('dialog');
        const old = dlg?.dataset.replaceKey ? before.items.find(i => i.key === dlg.dataset.replaceKey) : null;
        const sectionIds = [...document.querySelectorAll('cart-items-component')].map(el => el.dataset.sectionId).filter(Boolean);
        let data;
        if (old && String(old.variant_id) === String(variantId)) {
          data = await json('cart/change.js', { id: old.key, quantity: qty });
        } else {
          // Paid product succeeds independently of every optional gift.
          data = await json('cart/add.js', { items: [{ id: Number(variantId), quantity: qty }] });
        }
        // Only replace the previous choice after the paid product was accepted.
        if (old) {
          const remove = {};
          if (String(old.variant_id) !== String(variantId)) remove[old.key] = 0;
          before.items.forEach(i => {
            if (i.properties?._wsp_promotion_gift === 'true' && i.properties?._wsp_bundle_parent === String(old.variant_id)) remove[i.key] = 0;
          });
          if (Object.keys(remove).length) await json('cart/update.js', { updates: remove });
          dlg.dataset.replaceKey = '';
        }
        // A normal paid-item add does not change gift quantities from the pre-add cart.
        let cart = old ? await json('cart.js') : before;
        const end = new Date(this.querySelector('[data-gifts]')?.dataset.wspGiftEnd || this.querySelector('[data-wsp-gift-countdown]')?.dataset.end || 0).getTime();
        const gifts = (giftMap[variantId] || []).filter(([, , code]) => Date.now() < end || !String(code).includes('soup_'));
        const addedGiftQuantities = new Map();
        const giftItems = [];
        for (const [id, per, code] of gifts) {
          const available = stock[id];
          const amount = Number(per) * qty;
          const inCart = cart.items.filter(i => String(i.variant_id) === String(id)).reduce((n, i) => n + i.quantity, 0) + (addedGiftQuantities.get(String(id)) || 0);
          if (!available?.available || (available.quantity !== null && amount + inCart > available.quantity)) continue;
          giftItems.push({ id: Number(id), quantity: amount, properties: {
            _wsp_promotion_gift: 'true', _wsp_bundle_parent: String(variantId),
            _wsp_gift_per_bundle: String(per), _wsp_gift_code: String(code)
          } });
          addedGiftQuantities.set(String(id), (addedGiftQuantities.get(String(id)) || 0) + amount);
        }
        if (giftItems.length) {
          try {
            await json('cart/add.js', { items: giftItems });
          } catch (error) {
            console.warn('[WSP gifts] Batch add interrupted; reconciling cart', error);
            // A rejected request may still have added some stock. Read before retrying.
            const actual = await json('cart.js');
            const matches = (line, gift) => String(line.variant_id) === String(gift.id) &&
              Object.entries(gift.properties).every(([key, value]) => line.properties?.[key] === value);
            for (const gift of giftItems) {
              const original = cart.items.filter(line => matches(line, gift)).reduce((n, line) => n + line.quantity, 0);
              const current = actual.items.filter(line => matches(line, gift)).reduce((n, line) => n + line.quantity, 0);
              const remaining = Math.max(0, original + gift.quantity - current);
              if (!remaining) continue;
              try { await json('cart/add.js', { items: [{ ...gift, quantity: remaining }] }); }
              catch (giftError) { console.warn('[WSP gifts] Gift unavailable', gift.id, giftError); }
            }
          }
        }
        // Both reads follow the last cart mutation and can safely run together.
        const results = await Promise.all([
          json('cart.js'),
          sectionIds.length ? fetch(root + '?' + new URLSearchParams({ sections: sectionIds.join(',') }), { cache: 'no-store' })
            .then(response => response.json()).catch(error => { console.warn(error); return {}; }) : Promise.resolve({})
        ]);
        cart = results[0];
        const sections = results[1];
        this.cartTotal = cart.total_price || 0;
        this.updateShip();
        const paid = cart.items.reduce((n, i) => i.properties?._wsp_promotion_gift === 'true' ? n : n + i.quantity, 0);
        if (dlg?.open) dlg.close();
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'wsp-v2-pdp', data: { source: 'wsp-v2-pdp', itemCount: paid, variantId, sections } } }));
        if (this.bundleSheet?.open) this.bundleSheet.close();
        const drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') drawer.open(); else window.location.href = root + 'cart';
      } catch (error) {
        if (err) { err.textContent = error.message || window.WSP_T('add_fail'); err.hidden = false; }
      } finally {
        this._adding = false;
        buttons.forEach(b => { b.disabled = false; b.removeAttribute('aria-busy'); });
      }
    }
  });
}

/* Quick view: any [data-wsp-qv] link/button opens the product's buy box in a dialog. */
(function () {
  if (window.WSPQuickView) return;
  let dialog;
  function ensureDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'wsp2-qv';
    dialog.setAttribute('aria-label', window.WSP_T('quick'));
    dialog.innerHTML = '<button type="button" class="wsp2-qv__close" aria-label="' + window.WSP_T('close') + '">×</button><div class="wsp2-qv__body" data-qv-body></div>';
    dialog.querySelector('.wsp2-qv__close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => { document.documentElement.style.overflow = ''; });
    document.body.appendChild(dialog);
    return dialog;
  }
  async function open(url, trigger) {
    const d = ensureDialog();
    d.dataset.replaceKey = (trigger && trigger.dataset && trigger.dataset.wspQvReplace) || '';
    const body = d.querySelector('[data-qv-body]');
    body.innerHTML = '<div class="wsp2-qv__loading">' + window.WSP_T('loading') + '</div>';
    d.showModal();
    document.documentElement.style.overflow = 'hidden';
    try {
      const u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', 'wsp-v2-quickview');
      const res = await fetch(u.toString());
      if (!res.ok) throw new Error(res.status);
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const content = doc.querySelector('.wsp2-qv__content');
      if (!content) throw new Error('empty');
      body.replaceChildren(document.importNode(content, true));
      if (d.dataset.replaceKey) {
        // Opened from the cart's edit button: start from what's in the cart and say "update cart".
        const pdp = body.querySelector('wsp-pdp');
        const q = Number((trigger && trigger.dataset.wspQvQty) || 1);
        const input = body.querySelector('[data-qty]');
        if (input) input.value = q;
        if (pdp && typeof pdp.setQty === 'function') pdp.setQty(q);
        body.querySelectorAll('.wsp2-atc > span').forEach((span) => {
          if (span.firstChild && span.firstChild.nodeType === 3) span.firstChild.textContent = window.WSP_T('update_cart');
        });
      }
    } catch (e) {
      body.innerHTML = '';
      const p = document.createElement('p');
      p.className = 'wsp2-qv__loading';
      p.textContent = window.WSP_T('load_fail');
      const a = document.createElement('a'); a.href = url; a.textContent = window.WSP_T('see_page');
      p.appendChild(a); body.appendChild(p);
    }
  }
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-wsp-qv]');
    if (!t) return;
    e.preventDefault();
    open(t.dataset.wspQv, t);
  });
  // Cart drawer order note: single-line input + confirm button.
  document.addEventListener('submit', async (e) => {
    const f = e.target.closest && e.target.closest('[data-wsp-note]');
    if (!f) return;
    e.preventDefault();
    const btn = f.querySelector('button');
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (btn) { btn.disabled = true; btn.textContent = window.WSP_T('saving'); }
    try {
      await fetch(root + 'cart/update.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ note: f.elements.note.value }) });
      if (btn) btn.textContent = window.WSP_T('saved');
      setTimeout(() => { const box = f.closest('.wsp2-cx'); if (box) box.dataset.open = ''; if (btn) { btn.textContent = window.WSP_T('confirm'); btn.disabled = false; } }, 900);
    } catch (err) {
      if (btn) { btn.textContent = window.WSP_T('confirm'); btn.disabled = false; }
    }
  });
  window.WSPQuickView = { open };
})();
